import { formatCurrency } from 'shared/utils/common.utils';
import { useTranslation } from 'react-i18next';
import './styles.scss';

interface Props {
  totalAmount: number;
  totalSalAmount: number;
}

const BillingTotalsTable: React.FC<Props> = ({ totalAmount, totalSalAmount }) => {
  const { t } = useTranslation();

  return (
    <div className="d-flex justify-content-end align-items-center billing-totals-row py-2 px-3">
      <div className="d-flex align-items-center pe-3 border-end me-3">
        <span className="text-muted me-2">{t('project-detail.billing-plan.table.amount')}:</span>
        <span className="fw-bold text-blue-links">{`${formatCurrency(totalAmount)} €`}</span>
      </div>
      <div className="d-flex align-items-center">
        <span className="text-muted me-2">{t('project-detail.billing-plan.table.further-amount')}:</span>
        <span className="fw-bold text-blue-links">{`${formatCurrency(totalSalAmount)} €`}</span>
      </div>
    </div>
  );
};

export default BillingTotalsTable;
